import React from 'react';

const CommentDetails = ({ username, date, comment }) => {
  return (
    <>
        <h3 className='username'>{username}</h3>
        <p className='date'>{date}</p>
        <p className='comment'>{comment}</p>
    </>
  );
};

export default CommentDetails;
